export default "__VITE_ASSET__690cac0c__"